<template>
    <v-container class="pa-0">
        <v-row no-gutters>
            <v-col cols="6" sm="6">
                <v-row no-gutters class="pa-3">
                    <v-select v-model="fromYear" :items="years" label="fra år" filled hide-details :disabled="fromActive"></v-select>

                    <div class="mx-1"></div>

                    <v-menu v-model="showFrom" absolute :close-on-content-click="false">
                        <template v-slot:activator="{on}">
                            <v-text-field @click="clicked($event, on)" v-model="from" label="fra" readonly filled hide-details :disabled="!fromActive">
                                <template v-slot:prepend-inner>
                                    <v-checkbox v-model="fromActive" hide-details class="ma-0 pa-0"></v-checkbox>
                                </template>
                            </v-text-field>
                        </template>

                        <v-date-picker v-model="from" first-day-of-week="1" show-week locale="nb" :header-color="colors().background">
                            <v-btn text color="primary" @click="() => { from = moment().format('YYYY-MM-DD')}">i dag</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="showFrom = false">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-row>
            </v-col>

            <v-col cols="6" sm="6">
                <v-row no-gutters class="pa-3">
                    <v-select v-model="toYear" :items="years" label="til år" filled hide-details :disabled="toActive"></v-select>

                    <div class="mx-1"></div>

                    <v-menu v-model="showTo" absolute :close-on-content-click="false">
                        <template v-slot:activator="{on}">
                            <v-text-field @click="clicked($event, on)" v-model="to" label="til" readonly filled hide-details :disabled="!toActive">
                                <template v-slot:prepend-inner>
                                    <v-checkbox v-model="toActive" hide-details class="ma-0 pa-0"></v-checkbox>
                                </template>
                            </v-text-field>
                        </template>

                        <v-date-picker v-model="to" first-day-of-week="1" show-week locale="nb" :header-color="colors().background">
                            <v-btn text color="primary" @click="() => { to = moment().format('YYYY-MM-DD')}">i dag</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="showTo = false">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as moment from "moment";
import * as axios from "axios";

export default {
    props: ["initialFrom", "initialTo"],
    data() {
        return {
            startYear: undefined,
            years: [],
            showFrom: false,
            fromActive: false,
            fromYear: moment().year(),
            from: moment()
                .startOf("year")
                .format("YYYY-MM-DD"),

            showTo: false,
            toActive: false,
            toYear: moment().year(),
            to: moment()
                .endOf("year")
                .format("YYYY-MM-DD"),

            moment: moment
        };
    },
    watch: {
        from: function() {
            this.$emit("updated", this.from, this.to);
        },
        to: function() {
            this.$emit("updated", this.from, this.to);
        },
        fromYear: function(fromYear) {
            this.from = moment(fromYear, "YYYY")
                .startOf("year")
                .format("YYYY-MM-DD");

            if (fromYear > this.toYear) {
                this.toYear = this.fromYear;
            }

            this.$emit("updated", this.from, this.to);
        },
        toYear: function(toYear) {
            this.to = moment(toYear, "YYYY")
                .endOf("year")
                .format("YYYY-MM-DD");

            if (toYear < this.fromYear) {
                this.fromYear = this.toYear;
            }

            this.$emit("updated", this.from, this.to);
        },
        fromActive: function(fromActive) {
            if (!fromActive) {
                this.from = moment(this.fromYear, "YYYY")
                    .startOf("year")
                    .format("YYYY-MM-DD");
            }

            this.$emit("updated", this.from, this.to);
        },
        toActive: function(toActive) {
            if (!toActive) {
                this.to = moment(this.toYear, "YYYY")
                    .endOf("year")
                    .format("YYYY-MM-DD");
            }

            this.$emit("updated", this.from, this.to);
        }
    },
    methods: {
        clicked: function(event, on) {
            on.click(event);
        }
    },
    async mounted() {
        let response = await axios.get("/applicationSetting/name/startYear");
        this.startYear = Number(response.data.value);

        for (let year = this.startYear; year <= moment().year(); year++) {
            this.years.unshift(year);
        }

        if (this.initialFrom) {
            if (typeof this.initialFrom === "number") {
                this.from = moment.unix(this.initialFrom).format("YYYY-MM-DD");
            } else {
                if (/^\d{4}-\d{2}-\d{2}$/.test(this.initialFrom)) {
                    this.from = moment(this.initialFrom, "YYYY-MM-DD").unix().format("YYYY-MM-DD");
                }
                else{
                    this.from = moment().unix().format("YYYY-MM-DD");
                }
            }

            this.fromActive = true;
        }

        if (this.initialTo) {
            if (typeof this.initialTo === "number") {
                this.to = moment.unix(this.initialTo).format("YYYY-MM-DD");
            } else {
                if (/^\d{4}-\d{2}-\d{2}$/.test(this.initialTo)) {
                    this.to = moment(this.initialTo, "YYYY-MM-DD").format("YYYY-MM-DD");
                }
                else{
                    this.to = moment().format("YYYY-MM-DD");
                }
            }

            this.toActive = true;
        }

        this.$emit("updated", this.from, this.to);
    }
};
</script>

<style lang="scss">
</style>